import { Box, PrismicLogo } from "@prismicio/editor-ui"
import { type PropsWithChildren, Suspense } from "react"

export function AppSuspense({ children }: PropsWithChildren) {
  return <Suspense fallback={<Fallback />}>{children}</Suspense>
}

/**
 * This is a half-decent fallback UI that users should never see.
 * However, In case of a dev error, it's better than a blank page.
 *
 * The best/normal loading experience involves going straight from:
 * 1) The static HTML Prismic logo
 * to
 * 2) The top level Skeleton Suspense fallback for the given route.
 */
function Fallback() {
  if (import.meta.env.DEV)
    throw new Error(
      "Suspense Fallbacks must be handled closer to the views so we can show good loading skeletons"
    )

  return (
    <Box width="100%" justifyContent="center" padding={80}>
      <PrismicLogo />
    </Box>
  )
}
